import { siteInfo } from "@/mocks/site";
import { buildWhatsAppLink, TEL_LINK } from "@/utils/whatsapp";

export default function MobileBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-accent-500/30 bg-background-50/95 backdrop-blur-md lg:hidden">
      <div className="flex items-center gap-2 px-3 py-2.5">
        <a
          href={TEL_LINK}
          className="flex flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-3 py-3 font-label text-[0.68rem] font-semibold uppercase tracking-[0.1em] text-primary-700 transition-colors hover:border-primary-600"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-phone-line text-base" aria-hidden="true" />
          </span>
          Hemen Ara
        </a>
        <a
          href={buildWhatsAppLink(siteInfo.defaultMessage)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-[1.5] cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-3 py-3 font-label text-[0.68rem] font-semibold uppercase tracking-[0.1em] text-primary-950 transition-colors hover:bg-accent-400"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-whatsapp-line text-base" aria-hidden="true" />
          </span>
          WhatsApp’tan Randevu Al
        </a>
      </div>
    </div>
  );
}